//AppRoutes.tsx
import { RootComponent } from 'features/root/RootComponent';
import { Route, Routes } from 'react-router-dom';
import { RootLayout } from 'layouts/RootLayout';
import NotificationContainer from 'features/EmailPreview/NotificationContainer';
import HERContainer from 'features/HERPreview/HERContainer';

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Root redirect */}
      <Route path="/" element={<RootComponent/>} />

      {/* Main application routes with layout */}
      <Route path="/email-preview" element={
        <RootLayout>
          <NotificationContainer />
        </RootLayout>
      } />

      <Route path="/her-preview" element={
        <RootLayout>
          <HERContainer />
        </RootLayout>
      } />
    </Routes>
  )

}